interface WithTitle {
  locale: string
  title?: string
}

/** First non-blank translated title, else the given fallback. */
export const translationTitle = (
  translations: WithTitle[] | undefined,
  fallback: string,
): string => {
  const hit = translations?.find((t) => t.title && t.title.trim() !== '')
  return hit?.title?.trim() || fallback
}

interface WithName {
  locale: string
  name?: string
}

/** First non-blank translated name, else the given fallback. */
export const translationName = (
  translations: WithName[] | undefined,
  fallback: string,
): string => {
  const hit = translations?.find((t) => t.name && t.name.trim() !== '')
  return hit?.name?.trim() || fallback
}

interface WithText {
  locale: string
  text?: string
}

/** First non-blank translated text, else the given fallback. */
export const translationText = (
  translations: WithText[] | undefined,
  fallback: string,
): string => {
  const hit = translations?.find((t) => t.text && t.text.trim() !== '')
  return hit?.text?.trim() || fallback
}
